import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styles from "./LegalPage.module.css";

export default function LegalPage({ content }) {
  return (
    <div className={styles.wrap}>
      <div className={styles.container}>
        <div className={styles.card}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}
